export default {"src":"/_next/static/media/products_empty.f60e3ee8.svg","height":150,"width":220};